/*************************************************************************
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { observable, action } from "mobx";

class CursorStore {
  @observable cursorQuad;
  @observable cursorPageIndex;
  @observable isCursorVisible;

  constructor() {
    this.init();
  }

  @action
  init() {
    this.isCursorVisible = false;
    this.cursorQuad = [];
    this.cursorPageIndex = -1;
  }

  @action.bound
  setCursorInfo(selectTextRes) {
    if (
      selectTextRes &&
      selectTextRes.quads &&
      selectTextRes.quads.length > 0
    ) {
      this.cursorQuad = selectTextRes.quads[0];
      this.cursorPageIndex = selectTextRes.pageNum - 1;
    } else {
      this.cursorQuad = [];
      this.cursorPageIndex = -1;
    }
  }

  @action
  setIsCursorVisible(value) {
    this.isCursorVisible = value;
  }
}

export default CursorStore;
